import { combineReducers } from 'redux';
import { IBlogInitailType } from '../types/BlogListTypes';
import { ICarBrandsInitialType } from '../types/carBrandsTypes';
import { ICarCrtificationInitialType } from '../types/carCertificationTypes';
import { IInitialCarListType, IInitialCarType } from '../types/carListTypes';
import { ICarModelInitialType } from '../types/carModelsTypes';
import { ICarValuationInitialType } from '../types/carValuationTypes';
import { ICategoryInitailType } from '../types/categoryTypes';
import { IContactInformationInitialType } from '../types/contactInformationType';
import { IContactUsInitialType } from '../types/contactUsTypes';
import { IFilteredCarsFooterContentType } from '../types/filteredCarsFooterTypes';
import { IFinancePartnerInitialType } from '../types/financePartnerTypes';
import { IFinancingInitialType } from '../types/financingTypes';
import { IFooterContentType } from '../types/footerContentTypes';
import { IOurTeamInitialTypes } from '../types/ourTeamTypes';
import { IPagesInitialType } from '../types/pagesType';
import { IQuestionnaireInitialType } from '../types/questionnaireTypes';
import { ReferralState } from '../types/referral.types';
import { ISellingCarsInitialType } from '../types/sellCarTypes';
import { IServiceHistoryInitialType } from '../types/serviceHistoryTypes';
import { ISubscribeDataType } from '../types/subscribeTypes';
import { IWishListInitialType } from '../types/wishListTypes';
import appendClassInNavbarReducer, {
    IAppendClassToNavState
} from './appendClassInNavbarReducer';
import { authReducer, IAuthState } from './authReducer';
import blogReducer from './blogReducer';
import carBrandsReducer from './carBrandsReducer';
import carCertificationReducer from './carCertificationReducer';
import carListingReducer from './carListingReducer';
import carListReducer from './carListReducer';
import carModelsReducer from './carModelsReducer';
import carReducer, { ICarState } from './carReducer';
import carValuationReducer from './carValuationReducer';
import { categoryReducer } from './categoriesReducer';
import contactInformationReducer from './contactInformationReducer';
import contactReducer, { IContactState } from './contactReducer';
import contactUsReducer from './contactUsReducer';
import countryReducer, { ICountryState } from './countryReducer';
import customerGalleryReducer, {
    ICustomerGalleryState
} from './customerGalleryReducer';
import fetchCarListByTypeReducer, {
    ICarListTypeState
} from './fetchCarListByTypeReducer';
import FetchComingCarsReducer, {
    IComingCarsState
} from './fetchComingCarsReducer';
import fetchDataReducer from './fetchDataReducer';
import FetchFeaturedCarsReducer, {
    IFeaturedCarsState
} from './fetchFeaturedCarsReducer';
import FilterCarsFooterReducer from './filteredCarsFooterReducer';
import financeReducer from './financePartnerReducer';
import financingReducer from './financingsReducer';
import FooterContentReducer from './footerContentReducer';
import homeReducer, { IHomeState } from './homeReducer';
import ourTeamReducer from './ourTeamReducer';
import pagesReducer from './pagesReducer';
import pressReducer, { IPressState } from './pressReducer';
import faqsReducer, { createFaqReducer } from './questionnaireReducer';
import referralReducer from './referralReducer';
import sellingCarsReducer from './sellCarReducer';
import serviceHistoryReducer from './serviceHistoryReducer';
import storeReducer, { IStoreState } from './storeReducer';
import subscribeReducer from './susbcribeReducer';
import testimonialReducer, { ITestimonialState } from './testimonialReducer';
import wishListReducer from './wishlistReducer';

// you need to add all you new reducers here so that all reducers are combined
const rootReducer = combineReducers({
    auth: authReducer,
    fetchData: fetchDataReducer,
    carListing: carListingReducer,
    carListReducer: carListReducer,
    wishList: wishListReducer,
    faqs: faqsReducer,
    carCertification: carCertificationReducer,
    carBrands: carBrandsReducer,
    serviceHistory: serviceHistoryReducer,
    sellingCars: sellingCarsReducer,
    carModels: carModelsReducer,
    contactQuery: contactUsReducer,
    contactInformation: contactInformationReducer,
    pages: pagesReducer,
    financePartners: financeReducer,
    blogs: blogReducer,
    categories: categoryReducer,
    car: carReducer,
    home: homeReducer,
    featuredCars: FetchFeaturedCarsReducer,
    incomingCars: FetchComingCarsReducer,
    carListByType: fetchCarListByTypeReducer,
    testimonial: testimonialReducer,
    customerGallery: customerGalleryReducer,
    contact: contactReducer,
    store: storeReducer,
    country: countryReducer,
    subscriber: subscribeReducer,
    createFaq: createFaqReducer,
    financing: financingReducer,
    footerContent: FooterContentReducer,
    appendClassInNavbarReducer,
    ourTeam: ourTeamReducer,
    carValuation: carValuationReducer,
    filterCarsFooter: FilterCarsFooterReducer,
    press: pressReducer,
    referral: referralReducer
});

export default rootReducer;

export interface ICombineReducerType {
    fetchData: any;
    carListing: IInitialCarType;
    carListReducer: IInitialCarListType;
    wishList: IWishListInitialType;
    faqs: IQuestionnaireInitialType;
    carCertification: ICarCrtificationInitialType;
    carBrands: ICarBrandsInitialType;
    sellingCars: ISellingCarsInitialType;
    carModels: ICarModelInitialType;
    serviceHistory: IServiceHistoryInitialType;
    contactQuery: IContactUsInitialType;
    auth: IAuthState;
    car: ICarState;
    home: IHomeState;
    featuredCars: IFeaturedCarsState;
    incomingCars: IComingCarsState;
    carListByType: ICarListTypeState;
    testimonial: ITestimonialState;
    customerGallery: ICustomerGalleryState;
    contact: IContactState;
    store: IStoreState;
    country: ICountryState;
    contactInformation: IContactInformationInitialType;
    pages: IPagesInitialType;
    financePartners: IFinancePartnerInitialType;
    blogs: IBlogInitailType;
    categories: ICategoryInitailType;
    subscriber: ISubscribeDataType;
    createFaq: IQuestionnaireInitialType;
    financing: IFinancingInitialType;
    footerContent: IFooterContentType;
    appendClassInNavbarReducer: IAppendClassToNavState;
    ourTeam: IOurTeamInitialTypes;
    carValuation: ICarValuationInitialType;
    filterCarsFooter: IFilteredCarsFooterContentType;
    press: IPressState;
    referral: ReferralState;
}
